module.exports = __webpack_public_path__ + "static/img/r5.87c644b0.png";